import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Properties = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M7.29289 2.70711C7.68342 2.31658 8.31658 2.31658 8.70711 2.70711L13.2929 7.29289C13.6834 7.68342 13.6834 8.31658 13.2929 8.70711L8.70711 13.2929C8.31658 13.6834 7.68342 13.6834 7.29289 13.2929L2.70711 8.70711C2.31658 8.31658 2.31658 7.68342 2.70711 7.29289L7.29289 2.70711Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Properties
